<template>
  <!-- <div>商品分类列表</div> -->

  <div class="shop">
    <div class="top">
      <el-button size="small" type="primary" @click="onCreateClassifyClick"
        >新增分类</el-button
      >

      <el-button
        class="search"
        size="small"
        type="primary"
        @click="searchCategoryData"
        >搜索</el-button
      >
      <el-input
        class="search input"
        size="small"
        v-model="form.cate_id"
        placeholder="输入id查询"
        clearable
      ></el-input>
      <el-input
        class="search input"
        size="small"
        v-model="form.cate_name"
        placeholder="输入分类名称查询"
        clearable
      ></el-input>
    </div>

    <el-table
      :data="tableData"
      style="width:100%"
      max-height="600"
      :cell-style="tc"
      :header-cell-style="tccolor"
    >
      <el-table-column label="分类ID" prop="id" width="100"></el-table-column>
      <el-table-column label="分类icon" width="100">
        <template slot-scope="scope">
          <img
            :src="scope.row.icon || ''"
            style="width:50px;height:50px;object-fit:cover;"
          />
        </template>
      </el-table-column>
      <el-table-column label="分类名称" width="140">
        <template slot-scope="scope">
          {{ scope.row.cate_name }}
          <!--<span class="cetain"
            v-if="scope.row.isCertain">（固定）</span>-->
        </template>
      </el-table-column>
      <el-table-column
        label="已入库商品数量"
        prop="relation_product_count"
        width="140"
      ></el-table-column>
      <el-table-column label="展示排序" prop="order_sort"></el-table-column>
      <el-table-column
        label="展示端口"
        prop="free_shop_auth_name"
        width="140"
      ></el-table-column>
      <el-table-column label="分类状态">
        <template slot-scope="scope">
          <el-switch
            :key="scope.row.id"
            :active-value="1"
            :inactive-value="0"
            :value="scope.row.is_enable"
            @change="isUseActivityChange(scope.row.id, $event)"
          ></el-switch>
          <span>{{ scope.row.is_enable_word }}</span>
          <!-- <span v-else>已禁用</span> -->
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="240">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="changeShopCate(scope.row)"
            >编辑</el-button
          >
          <!-- <el-button size='mini'
            @click="gotoSaleDaily(scope.row.id)">销售日志</el-button> -->
          <el-button
            size="mini"
            @click="
              deleteShopCate(scope.row.id, scope.row.relation_product_count)
            "
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-col :span="24">
      <div class="pagination">
        <el-pagination
          background
          @current-change="pageChange"
          :current-page="form.page"
          :page-size="form.size"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-col>

    <jdialog
      :title="(showCate_id ? '编辑' : '新增') + '商品展示分类'"
      :visible.sync="isShowCategory"
      width="640px"
    >
      <el-form
        :model="cateForm"
        :rules="rules"
        class="demo-ruleForm"
        label-width="140px"
        ref="cateForm"
      >
        <el-form-item label="商品分类名称：" prop="cate_name">
          <el-input
            v-model="cateForm.cate_name"
            style="width:180px;"
            size="mini"
            placeholder="请输入商品分类名称"
          ></el-input>
        </el-form-item>

        <el-form-item label="商品分类排序：" prop="order_sort">
          <el-input
            v-model="cateForm.order_sort"
            style="width:140px;"
            size="mini"
            placeholder="0～99"
          ></el-input>
        </el-form-item>
        <el-form-item label="分类Icon：" prop="icon">
          <uploadImg
            flieName="icon"
            class="icon_cate"
            :oldImgs="[cateForm.icon]"
            :n="1"
            @getFile="getFile"
          ></uploadImg>
          <p class="note">支持png、jpg格式照片，大小不能超过1M</p>
        </el-form-item>
        <el-form-item label="分类专场图片：" prop="img_url">
          <uploadImg
            flieName="img_url"
            class="icon_cate"
            :oldImgs="[cateForm.img_url]"
            :n="1"
            @getFile="getFile"
          ></uploadImg>
          <p class="note">支持png、jpg格式照片，大小不能超过1M</p>
        </el-form-item>
        <el-form-item label="跳转方式：" prop="jump_link">
          <el-select
            v-model="cateForm.banner_type"
            size="mini"
            placeholder="请选择跳转类型"
            style="width:140px;margin-right:10px;"
            @change="changeClassify"
          >
            <el-option value="0" label="商品详情"></el-option>
            <el-option value="1" label="跳转链接"></el-option>
          </el-select>
          <el-input
            size="mini"
            :placeholder="
              cateForm.banner_type == 0 ? '请输入商品id' : '请输入链接'
            "
            style="width:240px;"
            v-model="cateForm.jump_link"
          ></el-input>
        </el-form-item>
        <el-form-item label="分类角标：" prop="corner_mark">
          <uploadImg
            flieName="corner_mark"
            class="icon_cate"
            :oldImgs="[cateForm.corner_mark]"
            :n="1"
            @getFile="getFile"
          ></uploadImg>
          <p class="note">支持png、jpg格式照片，大小不能超过1M</p>
        </el-form-item>
        <el-form-item label="展示端口：" prop="free_shop_auth">
          <el-select
            v-model="cateForm.free_shop_auth "
            size="mini"
            placeholder="请选择展示端口"
            style="width:140px;margin-right:10px;"
          >
            <el-option value="0" label="普通展示"></el-option>
            <el-option value="5" label="全部展示"></el-option>
            <el-option value="10" label="免费店展示"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否启用：">
          <el-radio-group v-model="cateForm.is_enable">
            <el-radio label="1">可用</el-radio>
            <el-radio label="0">不可用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <div class="align">
        <el-button size="mini" @click="isShowCategory = false">取消</el-button>
        <el-button size="mini" type="primary" @click="certainCategory"
          >确定</el-button
        >
      </div>
    </jdialog>
  </div>
</template>

<script>
import uploadImg from '@/components/uploadImg'
import {
  supplyproductCateList,
  productCateIsEnableUpdate,
  productCateCreate,
  productCateIdDelete,
  productCateIDUpdate
} from '@/api/autarky'
export default {
  components: {
    uploadImg
  },
  data() {
    return {
      isShowCategory: false,
      showCate_id: '',

      form: {
        cate_id: '',
        cate_name: '',
        page: 1,
        size: 20
      },

      total: 0,
      tableData: [],

      cateForm: {
        cate_name: '',
        order_sort: '',
        img_url: '',
        icon: '',
        jump_link: '',
        is_enable: '1',
        banner_type: '0',
        corner_mark:'',
        free_shop_auth: '0'
      },
      rules: {
        cate_name: [
          { required: true, message: '请输入商品分类名称', trigger: 'blur' },
          { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' }
        ],
        order_sort: [
          { required: true, message: '请输入商品分类排序', trigger: 'blur' }
        ],
        icon: [{ required: true, message: '请上传分类Icon', trigger: 'blur' }],
        img_url: [
          { required: true, message: '请上传分类专场图片', trigger: 'blur' }
        ],
        jump_link: [
          { required: true, message: '请输入商品id或跳转链接', trigger: 'blur' }
        ],
        free_shop_auth: [
          { required: true, message: '请选择展示端口', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.getsupplyproductCateListData()
  },
  watch: {
    isShowCategory(newV) {
      if (newV) {
        this.$refs.cateForm.resetFields()
      }
    }
  },
  methods: {
    onCreateClassifyClick() {
      this.isShowCategory = true
      this.cateForm = {
        cate_name: '',
        order_sort: '',
        img_url: '',
        icon: '',
        jump_link: '',
        is_enable: '1',
        banner_type: '0',
        corner_mark:'',
        free_shop_auth: '0'
      }
    },
    //搜索数据
    searchCategoryData() {
      this.getsupplyproductCateListData()
    },
    pageChange(page) {
      this.form.page = page
      //获取更多数据
      this.getsupplyproductCateListData()
    },
    //更改商品分类状态
    isUseActivityChange(id, e) {
      //更新成功后重新获取商品
      this.getproductCateIsEnableUpdateData(id, e)
    },

    //修改商品分类
    changeShopCate(data) {
      this.showCate_id = data.id
      this.cateForm = {
        cate_name: data.cate_name,
        order_sort: data.order_sort,
        img_url: data.img_url,
        icon: data.icon,
        jump_link: data.jump_link,
        is_enable: data.is_enable + '',
        banner_type: data.banner_type.toString(),
        corner_mark: data.corner_mark,
        free_shop_auth: data.free_shop_auth.toString(),
      }
      this.isShowCategory = true
    },
    //跳转销售日志
    gotoSaleDaily(id) {
      console.log(id)
      this.$router.push({
        path: './privateorderlist',
        query: { cate_id: id }
      })
    },
    //删除商品分类
    deleteShopCate(id, count) {
      if (Number(count) <= 0) {
        this.$confirm('确认删除该商品分类？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        })
          .then(() => {
            this.getproductCateIdDeleteData(id)
          })
          .catch(() => {
            console.log('cancel')
          })
      } else {
        this.$message.error('该分类里有入库商品，不能删除')
      }
    },
    // 选择跳转方式重置数据
    changeClassify(){
      this.cateForm.jump_link = ''
    },
    //确定新增 or 编辑分类
    certainCategory() {
      this.$refs.cateForm.validate(valid => {
        if (valid) {
          this.processProductCateData()
        } else {
          return false
        }
      })
    },
    //获取商品分类列表数据
    async getsupplyproductCateListData() {
      var url =
        'id=' +
        this.form.cate_id +
        '&cate_name=' +
        this.form.cate_name +
        '&page=' +
        this.form.page +
        '&is_enable='
      let res = await supplyproductCateList(url)
      if (res.code === 10000) {
        this.tableData = res.data.data
        this.total = res.data.total
      } else {
        this.$message.error(res.message)
      }
    },
    //更新商品分类可用状态
    async getproductCateIsEnableUpdateData(product_id, is_enable) {
      let res = await productCateIsEnableUpdate(product_id, {
        is_enable: is_enable
      })
      if (res.code === 10000) {
        this.$message.success(res.message)
        this.getsupplyproductCateListData()
      } else {
        this.$message.error(res.message)
      }
    },
    async processProductCateData() {
      let res
      if (this.showCate_id) {
        res = await productCateIDUpdate(this.showCate_id, this.cateForm)
      } else {
        res = await productCateCreate(this.cateForm)
      }

      if (res.code === 10000) {
        this.cateForm = {
          cate_name: '',
          order_sort: '',
          img_url: '',
          icon: '',
          jump_link: '',
          is_enable: '1',
          banner_type: '0',
          corner_mark:'',
          free_shop_auth: '0'
        }
        this.showCate_id = ''
        this.$message.success(res.message)
        this.getsupplyproductCateListData()
        this.isShowCategory = false
      } else {
        this.$message.error(res.message)
      }
    },
    //删除商品分类
    async getproductCateIdDeleteData(cate_id) {
      console.log(cate_id)
      let res = await productCateIdDelete(cate_id)
      if (res.code === 10000) {
        this.$message.success(res.message)
        this.getsupplyproductCateListData()
      } else {
        this.$message.error(res.message)
      }
    },
    getFile(file) {
      this.cateForm[file.name] = file.files.length > 0 ? file.files[0].url : ''
    },

    getModifyFile(file) {
      this.modifyForm[file.name] =
        file.files.length > 0 ? file.files[0].url : ''
    },
    tc() {
      return 'text-align:center; color:#333333; font-size:12px;'
    },
    tccolor() {
      return 'text-align:center;background-color:#f5f5f5; font-size:14px;'
    }
  }
}
</script>

<style lang="scss" scoped>
.shop {
  padding: 20px;
  .top {
    margin-bottom: 20px;
    .search {
      float: right;
      margin-left: 12px;
    }
    .input {
      width: 150px;
    }
  }

  .cetain {
    color: #f4222d;
  }
  .pagination {
    float: right;
    margin-top: 12px;
  }

  .icon_cate {
    float: left;
  }
  .demo-ruleForm {
    padding: 20px;
  }
  .note {
    color: #666666;
    font-size: 14px;
    margin-top: 28px;
  }
  .align {
    text-align: center;
  }
}
</style>
